<template>
<div>
  <v-autocomplete type="solo" :loading="load" standard label="Empresas" v-model="empresa" :items="empresas" return-object item-text="nomeFantasia"></v-autocomplete>
</div>
</template>

<script>
import service from '../../../services/userservice'
// import {
//   EventBus
// } from './../main'

export default {
  name: 'empresas-select',
  data () {
    return {
      empresas: [],
      empresa: {
        id: 0
      },
      load: false
    }
  },
  watch: {
    empresa (val) {
      this.$emit('empresa-select', this.empresa)
    }
  },
  methods: {
    listarEmpresas () {
      this.load = true
      service.listarEmpresas().then(r => {
        this.empresas = r.data
      }).finally(() => {
        this.load = false
      })
    }
  },
  mounted () {
    // this.criarGrafico(this.graficos)
    this.listarEmpresas()
  }
}
</script>
